<template>
  <div class="search box flex-column-center is-clipped is-shadowed has-text-white" :class="{active: isOpen}">
    <div class="search-label flex-center push" @click="toggle()">
      <svg class="" width="40.1" height="40.2" viewBox="0 0 40.1 40.2">
        <path d="M39.4,35.3h-.1L28.7,24.7a15.6,15.6,0,0,0,2.8-8.9A15.8,15.8,0,1,0,15.8,31.5a15.9,15.9,0,0,0,8.9-2.8L35.2,39.3a2.8,2.8,0,0,0,4.1.1,2.9,2.9,0,0,0,0-4.1Zm-23.6-8A11.5,11.5,0,1,1,27.3,15.8,11.5,11.5,0,0,1,15.8,27.3Z" style="fill:#fff" />
      </svg>
      <h2 class="is-size-4">SEARCH HONOREES</h2>
    </div>
    <div class="search-input push-top" v-show="isOpen">
      <input ref="input" type="text" v-on:keyup.enter="search()" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    search() {
      this.$router.push({
        name: 'search-results',
        params: { searchString: this.$refs.input.value }
      });
      this.isOpen = false;
      this.$refs.input.value = '';
    },
    toggle() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) this.$refs.input.focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

svg {
  margin-right: 15px;
  transform: scale(.85);
}
h2 {
  font-family: 'DIN Next LT Pro M';
}
input {
  width: 100%;
  height: 40px;
  padding: 15px;
  text-transform: uppercase;
  outline: none;
  border: 1px solid #b3b3b3;
}
.search {
  position: relative;
  height: 60px;
  background-color: $red;
  transition: height 0.2s ease-out;
  &.active {
    height: 130px;
  }
}
.search-input {
  width: 60%;
  max-width: 600px;
  @media screen and (max-width: 500px) {
    width: 80%;
  }
}
</style>
